export const VALIDATION_LIMITS = {
  MIN_RATE: 0,
  MAX_RATE: 1000,
  MIN_MARGIN: 0,
  MAX_MARGIN: 1000,
  MIN_STIPEND: 0,
  MAX_STIPEND: 1000000,
  MIN_HOURS: 0,
};

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'contract.validation.required',
  INVALID_NUMBER: 'contract.validation.invalidNumber',
  RATE_RANGE: 'contract.validation.rateRange',
  MARGIN_RANGE: 'contract.validation.marginRange',
  STIPEND_RANGE: 'contract.validation.stipendRange',
  HOURS_RANGE: 'contract.validation.hoursRange',
  POSITION_TEMPLATES_LOAD_ERROR: 'contract.validation.positionTemplatesLoadError',
  CONTRACT_CREATE_ERROR: 'contract.validation.createError',
  CONTRACT_CREATE_SUCCESS: 'contract.validation.createSuccess',
};

export default {
  VALIDATION_LIMITS,
  ERROR_MESSAGES,
};
